<form [formGroup]="saleAgentForm">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Base Commission Percentage'"
        [type]="'number'"
        [placeholder]="'Enter Base Commission Percentage'"
        formControlName="baseCommissionPercentage"
        [min]="0"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <currency-input-field
        [label]="'Base Commission Amount'"
        [placeholder]="'Enter Base Commission Amount'"
        formControlName="baseCommissionAmount"
        [control]="saleAgentForm.get('baseCommissionAmount')"
        [min]="0"
      >
      </currency-input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <input-field
        [label]="'Option Commission Percentage'"
        [type]="'number'"
        [placeholder]="'Enter Option Commission Percentage'"
        formControlName="optionCommissionPercentage"
        [min]="0"
      >
      </input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <currency-input-field
        [label]="'Option Commission Amount'"
        [placeholder]="'Enter Option Commission Amount'"
        formControlName="optionCommissionAmount"
        [control]="saleAgentForm.get('optionCommissionAmount')"
        [min]="0"
      >
      </currency-input-field>
    </div>
    <div class="col-lg-6 mb-3">
      <label class="form-label">Notes</label>
      <textarea class="form-control" [placeholder]="'Enter Notes'" formControlName="notes" rows="3"></textarea>
    </div>
    <div class="w-100"></div>
    <div class="col-lg-6 mb-3">
      <p class="me-2 mb-0 fs-14">Allow Commission On Base</p>
      <p-toggleswitch formControlName="allowCommissionOnBase" />
    </div>
    <div class="col-lg-6 mb-3">
      <p class="me-2 mb-0 fs-14">Allow Commission On Option</p>
      <p-toggleswitch formControlName="allowCommissionOnOption" />
    </div>
  </div>
</form>
